import { Select, Switch } from 'antd';
import { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { formatNumberWithCurrency, TComma } from '../../base/utils';
import { Box, Button, Input, Note, Page, Steps, Uniter } from '../../helbest';
import { API } from '../../request/api';
import { _Cart_Update } from '../../store/actions/cart_actions';
import { changeAddressId } from '../../store/actions/payment';

const Payment = ({ changeAddress, address_id }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state);

  const [national_id, set_national_id] = useState('');
  const [national_id_exists, set_national_id_exists] = useState(false);
  const [national_id_required, set_national_id_required] = useState(false);
  const [is_ni_valid, set_is_ni_valid] = useState(false);
  const [valid_national_id, set_valid_national_id] = useState(false);

  const [naghsh_code, set_naghsh_code] = useState('');
  const [naghsh_code_exists, set_naghsh_code_exists] = useState(false);
  const [naghsh_code_required, set_naghsh_code_required] = useState(false);

  const [first_name, set_first_name] = useState('');
  const [first_name_exists, set_first_name_exists] = useState(false);
  const [first_name_required, set_first_name_required] = useState(false);

  const [first_name_en, set_first_name_en] = useState('');
  const [first_name_en_exists, set_first_name_en_exists] = useState(false);
  const [first_name_en_required, set_first_name_en_required] = useState(false);

  const [last_name, set_last_name] = useState('');
  const [last_name_exists, set_last_name_exists] = useState(false);
  const [last_name_required, set_last_name_required] = useState(false);

  const [last_name_en, set_last_name_en] = useState('');
  const [last_name_en_exists, set_last_name_en_exists] = useState(false);
  const [last_name_en_required, set_last_name_en_required] = useState(false);

  const [father_name, set_father_name] = useState('');
  const [father_name_exists, set_father_name_exists] = useState(false);
  const [father_name_required, set_father_name_required] = useState(false);

  const [id_card_number, set_id_card_number] = useState('');
  const [id_card_number_exists, set_id_card_number_exists] = useState(false);
  const [id_card_number_required, set_id_card_number_required] = useState(false);

  const [id_card_serial, set_id_card_serial] = useState('');
  const [id_card_serial_exists, set_id_card_serial_exists] = useState(false);
  const [id_card_serial_required, set_id_card_serial_required] = useState(false);

  const [id_card_series, set_id_card_series] = useState('');
  const [id_card_series_exists, set_id_card_series_exists] = useState(false);
  const [id_card_series_required, set_id_card_series_required] = useState(false);

  const [phone_number, set_phone_number] = useState('');
  const [phone_number_exists, set_phone_number_exists] = useState(false);
  const [phone_number_required, set_phone_number_required] = useState(false);

  const [info_required, set_info_required] = useState(false);

  const [lock, set_lock] = useState(false);
  const [total_amount, set_total_amount] = useState(0);
  const [use_credit, set_use_credit] = useState(true);
  const [payable_amount, set_payable_amount] = useState(0);
  const [discount_code, set_discount_code] = useState('');
  const [delivery_amount, set_delivery_amount] = useState(0);
  const [discount_amount, set_discount_amount] = useState(0);
  const [can_use_credit, set_can_use_credit] = useState(true);
  const [usable_credit_amount, set_usable_credit_amount] = useState(0);
  const [credit_amount, set_credit_amount] = useState(0);
  const [has_cash_payment, set_has_cash_payment] = useState(false);
  const [is_locked_user_credit, set_is_locked_user_credit] = useState(false);

  const [provinces_list, set_provinces_list] = useState([]);
  const [cities_list, set_cities_list] = useState([]);
  const [regions_list, set_regions_list] = useState([]);

  const [address_exist, set_address_exist] = useState('');
  const [address_required, set_address_required] = useState(false);
  const [province_id, set_province_id] = useState();
  const [province_name, set_province_name] = useState('');
  const [city_id, set_city_id] = useState();
  const [city_name, set_city_name] = useState('');
  const [region_id, set_region_id] = useState();
  const [region_name, set_region_name] = useState('');
  const [address, set_address] = useState('');
  const [zip_code, set_zip_code] = useState('');

  const [zip_code_exist, set_zip_code_exist] = useState('');

  const { Option } = Select;

  const _SET_DISCOUNT_CODE = (has_discount = true, credit = use_credit) => {
    if (has_discount && discount_code.length < 3) {
      Note.error('کد تخفیف خود را به صورت درست وارد کنید.');
      return;
    }

    const CART = Array.isArray(store.Cart) ? [...new Set(store.Cart)] : [];

    API.post
      .orderSummary(credit, store.Login.city_id, discount_code, CART, address_id)
      .then((response) => {
        if (response.success) {
          set_delivery_amount(response.data.delivery_amount);
          set_can_use_credit(response.data.can_use_credit);
          set_payable_amount(response.data.payable_amount);
          set_discount_amount(response.data.discount_amount);
          set_total_amount(response.data.total_amount);
          set_discount_code(response.data.discount_code);
          set_usable_credit_amount(response.data.usable_credit_amount);
          set_credit_amount(response.data.credit_amount);
          set_use_credit(response.data.use_credit);
          set_has_cash_payment(response.data.has_cash_payment);
          set_is_locked_user_credit(response.data.is_locked_user_credit);

          dispatch(_Cart_Update(response.data.items));

          if (has_discount) {
            Note.success(response.message);
          }
          if (
            response.message &&
            response.message !== '' &&
            is_locked_user_credit &&
            !has_discount
          ) {
            Note.error(response.message);
          }
        } else {
          Note.error(response.message);
          if (response.code === 2001) {
            history.push('/cart/');
          } else if (response.code === 401) {
            history.push('/delivery/');
          } else {
            set_delivery_amount(response.data.delivery_amount);
            set_can_use_credit(response.data.can_use_credit);
            set_payable_amount(response.data.payable_amount);
            set_discount_amount(response.data.discount_amount);
            set_total_amount(response.data.total_amount);
            set_discount_code(response.data.discount_code);

            dispatch(_Cart_Update(response.data.items));
          }
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
        // history.push("/delivery/");
      });
  };

  const credit = (e) => {
    if (usable_credit_amount > 0) {
      set_use_credit(e);
      _SET_DISCOUNT_CODE(false, e);
    }
  };

  const getProvinces = () => {
    API.get
      .provinces()
      .then((Response) => {
        if (Response.success) {
          set_provinces_list(Response.data);
        }
        return Response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    const CART = Array.isArray(store.Cart) ? [...new Set(store.Cart)] : [];
    API.post
      .requiredFields(CART)
      .then((response) => {
        if (response.success) {
          set_info_required(response.data.length !== 0);

          set_first_name(response.data.first_name);
          set_first_name_exists(!!response.data.first_name);
          set_first_name_required('first_name' in response.data);

          set_first_name_en(response.data.first_name_en);
          set_first_name_en_exists(!!response.data.first_name_en);
          set_first_name_en_required('first_name_en' in response.data);

          set_last_name(response.data.last_name);
          set_last_name_exists(!!response.data.last_name);
          set_last_name_required('last_name' in response.data);

          set_last_name_en(response.data.last_name_en);
          set_last_name_en_exists(!!response.data.last_name_en);
          set_last_name_en_required('last_name_en' in response.data);

          set_father_name(response.data.father_name);
          set_father_name_exists(!!response.data.father_name);
          set_father_name_required('father_name' in response.data);

          set_id_card_number(response.data.id_card_number);
          set_id_card_number_exists(!!response.data.id_card_number);
          set_id_card_number_required('id_card_number' in response.data);

          set_id_card_serial(response.data.id_card_serial);
          set_id_card_serial_exists(!!response.data.id_card_serial);
          set_id_card_serial_required('id_card_serial' in response.data);

          set_id_card_series(response.data.id_card_series);
          set_id_card_series_exists(!!response.data.id_card_series);
          set_id_card_series_required('id_card_series' in response.data);

          set_phone_number(response.data.phone_number);
          set_phone_number_exists(!!response.data.phone_number);
          set_phone_number_required('phone_number' in response.data);

          set_national_id(response.data.national_id);
          set_national_id_exists(!!response.data.national_id);
          set_national_id_required('national_id' in response.data);

          set_is_ni_valid(response.data.is_ni_valid);
          set_national_id_exists('national_id' in response.data);
          set_national_id_required(response.data.is_ni_validation_required);
          set_valid_national_id(
            !response.data.is_ni_valid && response.data.is_ni_validation_required
          );

          set_naghsh_code(response.data.naghsh_code);
          set_naghsh_code_exists('naghsh_code' in response.data);
          set_naghsh_code_required('naghsh_code' in response.data);

          set_address_required('address' in response.data);
          set_province_id(response.data.address?.province_id);
          set_province_name(response.data.address?.province);
          set_city_id(response.data.address?.city_id);
          set_city_name(response.data.address?.city);
          set_region_id(response.data.address?.region_id);
          set_region_name(response.data.address?.region);
          set_zip_code(response.data.address?.zip_code);
          set_address(response.data.address?.address);
          set_address_exist(!!response.data.address?.address);
          set_zip_code_exist(!!response.data.address?.zip_code);

          if ('address' in response.data && !response.data.address?.address) {
            getProvinces();
          }
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });

    // eslint-disable-next-line
  }, []);

  const getCities = (province_id2) => {
    API.get
      .cities(province_id2)
      .then((Response) => {
        if (Response.success) {
          set_cities_list(Response.data);
        }
        return Response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  const getRegions = (city_id2) => {
    API.get
      .regions(city_id2)
      .then((Response) => {
        if (Response.success) {
          set_regions_list(Response.data);
        }
        return Response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  const _PAYMENT = () => {
    var CART = Array.isArray(store.Cart) ? [...new Set(store.Cart)] : [];
    set_lock(true);

    let user_data = {};
    let address_list = {
      latitude: 0.0,
      longitude: 0.0
    };

    if (national_id) {
      if (isNaN(national_id) || String(national_id).length !== 10) {
        set_lock(false);
        Note.error('کد ملی نامعتبر است');
        return;
      }
      user_data = { ...user_data, national_id: national_id };
    } else if (national_id_required) {
      set_lock(false);
      Note.error('لطفا کد ملی خود را وارد کنید ');
      return;
    }
    if (first_name_required) {
      if (first_name) {
        user_data = { ...user_data, first_name };
      } else {
        set_lock(false);
        Note.error('لطفا نام خود را وارد کنید ');
        return;
      }
    }
    if (last_name_required) {
      if (last_name) {
        user_data = { ...user_data, last_name };
      } else {
        set_lock(false);
        Note.error('لطفا نام خانوادگی خود را وارد کنید ');
        return;
      }
    }
    if (first_name_en_required) {
      if (first_name_en) {
        user_data = { ...user_data, first_name_en };
      } else {
        set_lock(false);
        Note.error('لطفا نام خود را به انگلیسی وارد کنید ');
        return;
      }
    }
    if (last_name_en_required) {
      if (last_name_en) {
        user_data = { ...user_data, last_name_en };
      } else {
        set_lock(false);
        Note.error('لطفا نام خانوادگی خود را به انگلیسی وارد کنید ');
        return;
      }
    }
    if (father_name_required) {
      if (father_name) {
        user_data = { ...user_data, father_name };
      } else {
        set_lock(false);
        Note.error('لطفا نام پدر خود را وارد کنید ');
        return;
      }
    }
    if (id_card_number_required) {
      if (id_card_number) {
        user_data = { ...user_data, id_card_number };
      } else {
        set_lock(false);
        Note.error('لطفا شماره شناسنامه خود را وارد کنید ');
        return;
      }
    }
    if (id_card_serial_required) {
      if (id_card_serial) {
        user_data = { ...user_data, id_card_serial };
      } else {
        set_lock(false);
        Note.error('لطفا  سریال شناسنامه خود را وارد کنید ');
        return;
      }
    }
    if (id_card_series_required) {
      if (id_card_series) {
        user_data = { ...user_data, id_card_series };
      } else {
        set_lock(false);
        Note.error('لطفا سری شناسنامه خود را وارد کنید ');
        return;
      }
    }
    if (phone_number_required) {
      if (phone_number) {
        user_data = { ...user_data, phone_number };
      } else {
        set_lock(false);
        Note.error('لطفا شماره تلفن خود را وارد کنید ');
        return;
      }
    }

    if (naghsh_code_required || naghsh_code_exists) {
      user_data.naghsh_code = naghsh_code;
    }

    if (address_required) {
      if (province_id) {
        address_list = { ...address_list, province_id };
      } else {
        set_lock(false);
        Note.error('لطفا استان خود را انتخاب کنید ');
        return;
      }

      if (city_id) {
        address_list = { ...address_list, city_id };
      } else {
        set_lock(false);
        Note.error('لطفا شهر خود را انتخاب کنید ');
        return;
      }

      if (region_id) {
        address_list = { ...address_list, region_id };
      } else {
        set_lock(false);
        Note.error('لطفا منطقه خود را انتخاب کنید ');
        return;
      }

      if (address) {
        address_list = { ...address_list, address };
      } else {
        set_lock(false);
        Note.error('لطفا آدرس خود را وارد کنید ');
        return;
      }

      if (zip_code) {
        address_list = { ...address_list, zip_code };
      } else {
        set_lock(false);
        Note.error('لطفا کدپستی خود را وارد کنید ');
        return;
      }
      user_data = { ...user_data, address: address_list };
    }

    API.post
      .payment(store.Login.city_id, use_credit, discount_code, CART, user_data, address_id)
      .then((response) => {
        if (response.success) {
          window.location.replace(response.data.payment_url);
        } else {
          set_lock(false);
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        set_lock(false);
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    if (!address_id) {
      history.push('/delivery');
    }
    return () => {
      changeAddress(null);
    };
  }, [address_id]); // eslint-disable-line

  // const Footer = () =>

  useEffect(() => {
    if (is_locked_user_credit) {
      _SET_DISCOUNT_CODE(false, false);
    } else {
      _SET_DISCOUNT_CODE(false, true);
    }
  }, [is_locked_user_credit]);

  return (
    <Page
      address="/cart/"
      back
      className="page-payment"
      footer={
        !lock ? (
          <div className="page-payment-footer">
            <Button onClick={() => _PAYMENT()}>
              {has_cash_payment ? 'ثبت سفارش' : 'پرداخت و ثبت سفارش'}
            </Button>
          </div>
        ) : (
          <div className="page-payment-footer">
            <p className="yekan text-center mt-3">
              {has_cash_payment ? (
                <span>در حال تائید سفارش ...</span>
              ) : (
                <span>در حال انتقال به بانک ...</span>
              )}
            </p>
          </div>
        )
      }
      headerFix
      logo
      mobileContainer
      showFooter
      title="پرداخت">
      <Steps step={3} />

      <section className="payment-page-body">
        <Box className="payment-data-wrap-up">
          <div className="ws-100 mar-b-10">
            <span>جمع سفارش</span>
            <Uniter className="" unit="تومان">
              {total_amount}
            </Uniter>
          </div>

          <div className="ws-100 mar-b-10">
            <span>تخفیف کالا</span>
            <Uniter className="" unit="تومان">
              {store.Login?.cart_data?.discount_amount}
            </Uniter>
          </div>

          {discount_amount ? (
            <div className="ws-100 mar-b-10">
              <span>کد تخفیف</span>
              <Uniter className="" unit="تومان">
                {discount_amount}
              </Uniter>
            </div>
          ) : null}

          {delivery_amount ? (
            <div className="ws-100 mar-b-10">
              <span>هزینه تحویل</span>
              <Uniter className="" unit="تومان">
                {delivery_amount}
              </Uniter>
            </div>
          ) : null}

          {can_use_credit ? (
            <div className="ws-100">
              <span>
                استفاده از اعتبار{' '}
                <Switch
                  checked={use_credit}
                  className="mar-r-15"
                  defaultChecked={use_credit}
                  disabled={!usable_credit_amount}
                  onChange={(e) => credit(e)}
                />
              </span>
              {formatNumberWithCurrency(TComma(credit_amount))}
            </div>
          ) : null}

          <div className="payment-data-line-break" />

          <div className="ws-100">
            {has_cash_payment ? (
              <span>مبلغ قابل پرداخت در محل</span>
            ) : (
              <span>مبلغ قابل پرداخت</span>
            )}
            <Uniter className="payment-data-price" unit="تومان">
              {payable_amount}
            </Uniter>
          </div>
        </Box>

        <div className="payment-page-discount">
          <Input
            data={discount_code}
            dataHandler={(value) => set_discount_code(value)}
            placeholder="اگر کد تخفیف دارید اینجا وارد کنید"
          />
          <Button onClick={() => _SET_DISCOUNT_CODE()} type="submit">
            اعمال کد تخفیف
          </Button>
        </div>

        {info_required ? (
          <Box className="payment-page-input-box">
            <p>اطلاعات شخصی</p>
            {national_id_exists || national_id_required ? (
              <Input
                className="input-item mar-b-10"
                data={national_id}
                dataHandler={(value) => set_national_id(value)}
                disabled={is_ni_valid}
                inputMode="numeric"
                label="کد ملی"
                maxLength="10"
                pattern="[0-9]*"
              />
            ) : null}

            {first_name_required ? (
              <Input
                className="input-item mar-b-10"
                data={first_name}
                dataHandler={(value) => set_first_name(value)}
                disabled={first_name_exists}
                label="نام"
                maxLength="30"
              />
            ) : null}

            {last_name_required ? (
              <Input
                className="input-item mar-b-10"
                data={last_name}
                dataHandler={(value) => set_last_name(value)}
                disabled={last_name_exists}
                label="نام خانوادگی"
                maxLength="150"
              />
            ) : null}

            {first_name_en_required ? (
              <Input
                className="input-item mar-b-10"
                data={first_name_en}
                dataHandler={(value) => set_first_name_en(value)}
                disabled={first_name_en_exists}
                label="نام به انگلیسی"
                maxLength="50"
              />
            ) : null}

            {last_name_en_required ? (
              <Input
                className="input-item mar-b-10"
                data={last_name_en}
                dataHandler={(value) => set_last_name_en(value)}
                disabled={last_name_en_exists}
                label="نام خانوادگی به انگلیسی"
                maxLength="150"
              />
            ) : null}

            {father_name_required ? (
              <Input
                className="input-item mar-b-10"
                data={father_name}
                dataHandler={(value) => set_father_name(value)}
                disabled={father_name_exists}
                label="نام پدر"
                maxLength="150"
              />
            ) : null}

            {id_card_number_required ? (
              <Input
                className="input-item mar-b-10"
                data={id_card_number}
                dataHandler={(value) => set_id_card_number(value)}
                disabled={id_card_number_exists}
                inputMode="numeric"
                label="شماره شناسنامه"
                maxLength="10"
                pattern="[0-9]*"
              />
            ) : null}

            {id_card_serial_required ? (
              <Input
                className="input-item mar-b-10"
                data={id_card_serial}
                dataHandler={(value) => set_id_card_serial(value)}
                disabled={id_card_serial_exists}
                inputMode="numeric"
                label="سریال شناسنامه"
                maxLength="6"
                pattern="[0-9]*"
              />
            ) : null}

            {id_card_series_required ? (
              <Input
                className="input-item mar-b-10"
                data={id_card_series}
                dataHandler={(value) => set_id_card_series(value)}
                disabled={id_card_series_exists}
                label="سری شناسنامه"
                maxLength="10"
              />
            ) : null}

            {phone_number_required ? (
              <Input
                className="input-item mar-b-10"
                data={phone_number}
                dataHandler={(value) => set_phone_number(value)}
                disabled={phone_number_exists}
                inputMode="numeric"
                label="شماره تلفن"
                maxLength="15"
                pattern="[0-9]*"
              />
            ) : null}

            {naghsh_code_exists || naghsh_code_required ? (
              <Input
                className="input-item mar-b-10"
                data={naghsh_code}
                dataHandler={(value) => set_naghsh_code(value)}
                disabled={naghsh_code_exists}
                inputMode="numeric"
                label="کد نقش"
                maxLength="20"
                pattern="[0-9]*"
              />
            ) : null}

            {address_required ? (
              <>
                <p className="font-12">آدرس محل سکونت</p>
                <Select
                  className="input-item mar-b-10"
                  disabled={address_exist}
                  onChange={(province_id2) => {
                    set_province_id(province_id2);
                    set_city_id();
                    set_regions_list([]);
                    set_region_id();
                    getCities(province_id2);
                  }}
                  optionFilterProp="name"
                  placeholder="استان"
                  showSearch
                  style={{ width: '100%' }}
                  value={province_id}>
                  {address_exist ? (
                    <Option value={province_id}>{province_name}</Option>
                  ) : (
                    provinces_list?.map((province, i) => (
                      <Option key={i} name={province.name} value={province.id}>
                        {province.name}
                      </Option>
                    ))
                  )}
                </Select>
                <Select
                  className="input-item mar-b-10"
                  disabled={address_exist || !province_id}
                  onChange={(city_id2) => {
                    set_city_id(city_id2);
                    set_region_id();
                    getRegions(city_id2);
                  }}
                  optionFilterProp="name"
                  placeholder="شهر"
                  showSearch
                  style={{ width: '100%' }}
                  value={city_id}>
                  {address_exist ? (
                    <Option value={city_id}>{city_name}</Option>
                  ) : (
                    cities_list?.map((city, i) => (
                      <Option key={i} name={city.name} value={city.id}>
                        {city.name}
                      </Option>
                    ))
                  )}
                </Select>
                <Select
                  className="input-item mar-b-10"
                  disabled={address_exist || !city_id}
                  onChange={(region_id2) => set_region_id(region_id2)}
                  optionFilterProp="name"
                  placeholder="منطقه"
                  showSearch
                  style={{ width: '100%' }}
                  value={region_id}>
                  {address_exist ? (
                    <Option value={region_id}>{region_name}</Option>
                  ) : (
                    regions_list?.map((region, i) => (
                      <Option key={i} name={region.name} value={region.id}>
                        {region.name}
                      </Option>
                    ))
                  )}
                </Select>
                <textarea
                  className="input-item mar-b-10 textarea-input-payment"
                  disabled={address_exist || !region_id}
                  onChange={(e) => set_address(e.target.value)}
                  placeholder="آدرس را بدون استان، شهر و منطقه وارد کنید."
                  value={address}
                />
                <Input
                  className="input-item mar-b-10"
                  data={zip_code}
                  dataHandler={(value) => set_zip_code(value)}
                  disabled={zip_code_exist || !region_id}
                  inputMode="numeric"
                  label="کدپستی"
                  maxLength="10"
                  pattern="[0-9]*"
                />
              </>
            ) : null}
          </Box>
        ) : null}
      </section>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  address_id: state.Payment.address_id
});

const mapDispatchToProps = (dispatch) => ({
  changeAddress: (id) => dispatch(changeAddressId(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
